import React from 'react'
import styled from 'styled-components'
import AccountTemplate from 'components/templates/AccountTemplate'
import SignUpBox from 'components/organisms/SignUpBox'
import LoginForm from 'containers/organisms/LoginForm'
import LoadingView from 'components/atoms/LoadingView'
import SocialLoginForm from 'components/organisms/SocialLoginForm'
import path from 'routes/path'
import { mediaMax } from 'frontend_core/dist/styles/media'

// PC用レイアウト（768px以上で表示）
const PcLayout = styled.div`
  display: block;
  ${mediaMax.phone`
    display: none;
  `}
`

// SP用レイアウト（767px以下で表示）
const SpLayout = styled.div`
  display: none;
  ${mediaMax.phone`
    display: block;
  `}
`
export default props => {
  return (
    <AccountTemplate
      title={props.title}
      description={props.description}
      linkCanonical={props.linkCanonical}
      currentUser={props.currentUser}
      breadcrumbs={props.breadcrumbs}
      config={props.config}
    >
      {props.isLoading && <LoadingView />}
      <div className="signup-border lp-page__padding">
        <div className="page__col1">
          <div className="signup-head">
            <h1 className="page-title">{i18n.t('page.shared.l_00015')}</h1>
          </div>

          {/* PC用レイアウト */}
          <PcLayout>
            <SignUpBox {...props} showAppLink />
            <div className="signup-box signup-box__line">
              <div className="row col-signup__pd">
                <SocialLoginForm {...props} />
                <div className="col-sm-12 col-md-6 sm-signup-box__line">
                  <LoginForm {...props} />
                  <div className="ta-c">
                    <p>
                      <a href={path.passwordReset()} className="a__underline">
                        {i18n.t('page.account.l_00019')}
                      </a>
                    </p>
                    <p className="mt10">
                      <a
                        href="https://support.spacemarket.com/ja/articles/4120e6df"
                        rel="noopener noreferrer"
                        target="_blank"
                        className="a__underline"
                      >
                        ログインできない方はこちら
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </PcLayout>

          {/* SP用レイアウト */}
          <SpLayout>
            {/* 新規登録ボックス（SP用アプリセクション含む） */}
            <SignUpBox {...props} showAppLink />

            {/* 外部アカウントログインボックス */}
            <div className="signup-box">
              <SocialLoginForm {...props} isSpLayout />
            </div>

            {/* メールアドレスでログインボックス */}
            <div className="signup-box">
              <LoginForm {...props} />
              <div className="ta-c">
                <p>
                  <a href={path.passwordReset()} className="a__underline">
                    {i18n.t('page.account.l_00019')}
                  </a>
                </p>
                <p className="mt10">
                  <a
                    href="https://support.spacemarket.com/ja/articles/4120e6df"
                    rel="noopener noreferrer"
                    target="_blank"
                    className="a__underline"
                  >
                    ログインできない方はこちら
                  </a>
                </p>
              </div>
            </div>
          </SpLayout>
        </div>
      </div>
    </AccountTemplate>
  )
}
